import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../icons';
import { IconButton } from './styles';

const TYPES = {
  back: {
    icon: 'chevron-left',
    name: 'Back',
  },
  forward: {
    icon: 'chevron-right',
    name: 'Forward',
  },
};

export const NavButton = ({ onClick, type }) => {
  const button = TYPES[type];
  return (
    <IconButton type="button" onClick={onClick} aria-label={button.name}>
      <Icon iconName={button.icon} size="25px" alt="" id="nav_button" />
    </IconButton>
  );
};
NavButton.displayName = 'NavButton';
NavButton.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['back', 'forward']).isRequired,
};
